// src/components/atoms/MiraiSession/MiraiSession.tsx
import React, { useEffect, useRef } from 'react';

// Tipado global para evitar errores de TypeScript
declare global {
    interface Window {
        miraiCore: any;
    }
}

interface MiraiSessionProps {
    hotelId?: string;
}

const MiraiSession: React.FC<MiraiSessionProps> = ({ hotelId = '100376918' }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    // Configuración fija en inglés para consistencia
    const FIXED_LOCALE = 'en-US';
    const CONTAINER_ID = 'mirai-session-container';
    const SCRIPT_ID = 'mirai-core-script';

    useEffect(() => {
        const SCRIPT_URL = 'https://static.mirai.com/core/index.js';
        const CSS_URL = 'https://static.mirai.com/core/index.css';

        // 1. Cargar CSS si no existe
        if (!document.querySelector(`link[href="${CSS_URL}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = CSS_URL;
            document.head.appendChild(link);
        }

        // 2. Función de inicialización
        const initWidget = () => {
            setTimeout(() => {
                if (window.miraiCore && containerRef.current) {
                    console.log("🚀 Mirai Session Widget Loaded");
                    try {
                        window.miraiCore.init({
                            selector: `#${CONTAINER_ID}`,
                            hotelId: hotelId,
                            language: FIXED_LOCALE
                        });
                    } catch (e) {
                        console.error("Error init Mirai Session:", e);
                    }
                }
            }, 100);
        };

        // 3. Cargar script solo si no existe
        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = SCRIPT_URL;
            script.async = true;
            script.onload = initWidget;
            document.body.appendChild(script);
        } else {
            initWidget();
        }

    }, [hotelId]);

    return (
        <div
            ref={containerRef}
            id={CONTAINER_ID}
            className="mirai-session-wrapper"
            style={{
                minHeight: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <div
                data-mirai-id={hotelId}
                data-locale={FIXED_LOCALE}
                style={{ display: 'none' }}
            ></div>

            <div
                data-mirai-component="session"
                data-locale={FIXED_LOCALE}
            ></div>
        </div>
    );
};

export default MiraiSession;